import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import PropertiesByCategoriesMultiSelectFilter from './Filters/PropertiesByCategoriesMultiSelectFilter';
import Content from '../Interest/General/Content';
import Filters from '../Interest/General/Filters';
import SubmitFilter from '../Interest/Filters/SubmitFilter';
import PropertiesPerPropertyTable from '../Interest/InterestTables/PropertiesPerPropertyTable';

import { MAX_AMOUNT_SELECTED, PROPERTIES_PER_PROPERTY_FILTER } from '../../Constants/Interest/Filter';
import { Filter } from '../../Enum/Filters';
import InterestUri from '../../Enum/InterestUri';

import { disablePdfButton } from '../../Store/Pdf/action';
import useGetFilterValue from '../../Hook/Interest/UseGetFilterValue';

const PropertiesPerProperty: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(disablePdfButton());
    }, []);

    const filterValues = useGetFilterValue(Filter.MortgageProperties) as string[];

    return (
        <div className="interest-content-wrapper" data-testid="properties-per-property">
            <Filters filterTotals={{
                amountSelected: filterValues.length,
                maxAmountSelected: MAX_AMOUNT_SELECTED
            }}>
                <SubmitFilter filterProperties={PROPERTIES_PER_PROPERTY_FILTER}
                              section={InterestUri.PropertiesPerProperty}
                />
                <hr className="mb-3" />
                <PropertiesByCategoriesMultiSelectFilter />
            </Filters>
            <Content>
                <PropertiesPerPropertyTable />
            </Content>
        </div>
    );
};

export default PropertiesPerProperty;
